/**
 * Get a properly formatted label for a category
 */
export const getCategoryLabel = (category: string): string => {
  switch (category) {
    case 'MARKETING':
      return 'Marketing'
    case 'UTILITY':
      return 'Utility'
    case '':
    case null:
    case undefined:
      return 'Unknown'
    default:
      return 'Unknown'
  }
}
